// extracted by mini-css-extract-plugin
export default {"title":"AuthPage_title__JWiev","container":"AuthPage_container__vTUhn"};